import { ClientT } from '../../../types/Users'
import { FILTERS_JOBS_SAVE } from '../../../redux/reducers/filtersJobsReducer'

export interface FiltersT {
  startDate: string
  endDate: string
  jobStatus: Array<string>
  jobType: Array<string>
  client: ClientT | null
}

export const InitFiltersJobs: FiltersT = {
  startDate: "",
  endDate: "",
  jobStatus: [],
  jobType: [],
  client: null,
}

// save in redux
export const saveFilters = (filters: FiltersT) => dispatch => {
  dispatch({ type: FILTERS_JOBS_SAVE, payload: filters })
}
